module.exports = __webpack_public_path__ + "static/media/cuenta1.3b5cb3c4.jpg";